<template>
  <AppHeader class="header text-sm !bg-gs-purple" :title="title || ''">
    <template #right>
      <NavMenu v-if="isShowNavMenu" />
      <ResourceMenu />
      <HelpMenu />
      <LanguagePicker />
      <UserAvatar>
        <template #extraItems>
          <DropdownItem v-if="testDeviceShown" :text="testConnectText" @click.prevent="() => toggleModal(true)" />
        </template>
      </UserAvatar>
    </template>
  </AppHeader>
</template>
<style src="./header.scss" lang="scss" scoped></style>
<script src="./header.ts" lang="ts"></script>
